import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  value: null
}
const _hoisted_2 = ["value"]

import { watch, reactive, onMounted } from 'vue';
import * as service from '@/services/clientesService';

interface Props {
  modelValue?: number | null,
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownClientes',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit


var controle = reactive({
  items: [] as service.Cliente[],
  id: null as number | null,
  carregando: false,
  text: "",
  status: ""
})

onMounted(() => {
  buscarItens()
})



function selecionar() {

  var cliente = controle.items.find(c => c.clienteId === controle.id)
  if (cliente) {
    emit('update:modelValue', cliente.clienteId)
    emit('selected', cliente)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | null | undefined>(() => props.modelValue, (newValue) => {
  controle.id = newValue ?? null;
})


async function buscarItens() {
  controle.status = "Buscando...";

  try {
    var r = await service.obterResumido({ ativo: true, tamanhoPagina: 6000, ordenarPor: "nome" });
    controle.items = r.dados;
    controle.status = "";
  }
  catch (error: any) {
    console.error("Erro ao buscar itens:", error);
    controle.status = `Erro ${error.message}`;
  }
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).id) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [
    (_unref(controle).status)
      ? (_openBlock(), _createElementBlock("option", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-spin" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "- Selecione -", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).items, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.clienteId,
              value: item.clienteId
            }, _toDisplayString(item.nome) + " - " + _toDisplayString(item.cpf), 9, _hoisted_2))
          }), 128))
        ], 64))
  ], 544)), [
    [_vModelSelect, _unref(controle).id]
  ])
}
}

})